var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-uploader-container"},[_c('p',{staticClass:"video-uploader-title"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('input',{staticClass:"video-uploader-button",attrs:{"type":"file","accept":"video/mp4"},on:{"change":_vm.uploadVideo}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2927a32a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/VideoUploader.vue
// module id = null
// module chunks = 